class HHLoadMore extends HTMLElement {
    constructor() {
        super();
        this.position = "next";
    }

    connectedCallback() {
        this.addEventListener("submit", this.handleLoadMore.bind(this));
        // Initialize properties from attributes
        this.url = this.getAttribute('url');
        this.position = this.getAttribute('position') || 'next'; // Default to 'next'
        this.targetClass = this.getAttribute('target-class');
    }

    disconnectedCallback() {
        // Cleanup if necessary
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'url') {
            this.url = newValue;
        } else if (name === 'position') {
            this.position = newValue;
        } else if (name === 'target-class') {
            this.targetClass = newValue;
        }
    }

    static get observedAttributes() {
        return ['url', 'position', 'target-class'];
    }

    async handleLoadMore(e) {
        e.preventDefault();
        try {
            const url = this.url;
            const targetClass = this.targetClass;
            this.setButtonLoading();
            // if (this.position === "next") {
            this.setPageUrl(url);
            // }
            const data = await (await fetch(url)).text();
            const dataDom = new DOMParser().parseFromString(data, "text/html");
            const newData = dataDom.querySelector(targetClass);
            document.querySelector(targetClass).insertAdjacentHTML(this.position === 'previous' ? 'afterbegin' : 'beforeend', newData.innerHTML);
            this.rerenderComponent(dataDom);
        } catch (error) {
            console.error(error);
        }
    }

    setButtonLoading() {
        const buttonEl = this.querySelector('.js-load-more, button[type="submit"]');
        buttonEl.classList.add("is-loading");
        buttonEl.disabled = true;
    }

    rerenderComponent(data) {
        if (!data) return;
        const elId = `#${this.getAttribute("id")}`;
        const newLoadMore = data.querySelector(elId)?.outerHTML || "";
        this.outerHTML = newLoadMore;
    }

    setPageUrl(url) {
        window.history.pushState({}, "", url);
    }
}

customElements.define("hh-load-more", HHLoadMore);